import React from 'react';
import extendClassNameWithModifier from '../../../lib/bemUtils/bem';
import { Heading } from '../Heading/Heading';
import { Modifier } from '../../../lib/bemUtils/Modifier';

export enum ContentBlockHeadlineModifier {
  paddingBottom = 'content-block-headline--padding-bottom',
  gray = 'content-block-headline--gray',
}

type ContentBlockHeadline = {
  title?: string;
  hierarchy?: number;
  modifier?: Modifier<ContentBlockHeadlineModifier>;
};

export function ContentBlockHeadline({ title, hierarchy = 2, modifier }: ContentBlockHeadline) {
  if (!title) {
    return null;
  }

  return (
    <Heading hierarchy={hierarchy} className={extendClassNameWithModifier('content-block-headline', modifier)}>
      {title}
    </Heading>
  );
}
